module.exports = __webpack_public_path__ + "img/Menu-06.949ef520.webp";